



































import {Component, Prop, Vue} from 'vue-property-decorator';
import {RouteConfig} from 'vue-router';

const tagNames = ['布局', '导航', '数据入口', '数据展示', '反馈', '手势', '组合', '其他'];
@Component
export default class NavList extends Vue {
  @Prop({
    type: Array
  })
  public menuList: RouteConfig[]; // 代码片段

  public openKeys: string[] = [];

  public getComponentMap(routes: RouteConfig[]) {
    const tags = routes.map(it => it.meta && it.meta.tag);
    const map = {};
    tags.forEach(tag => {
      map[tag] = routes.filter(it => it.meta.tag === tag);
    });
    const tagComponentsList = [];
    Object.keys(map).forEach(key => {
      tagComponentsList.push({
        tag: key,
        components: map[key]
      });
    });
    tagComponentsList.sort((a, b) => {
      return tagNames.indexOf(a.tag) - tagNames.indexOf(b.tag);
    });
    return tagComponentsList;
  }

  public handleClick(route) {
    this.$router.push(route);
  }

}
